export const Text = ({ characters, className }) => {
    return (
        <>
            <p className={className}>{characters}</p>
        </>
    );
};
